import type { ReactNode } from "react";

/**
 * The keyboard way into a detail sheet a table row also opens on click. The row
 * click stays, and its bubbled duplicate sets the same key, so both agree.
 */
export function RowDetailButton({
  onSelect,
  children,
}: {
  onSelect: () => void;
  children: ReactNode;
}) {
  return (
    <button
      type="button"
      className="block w-full cursor-pointer rounded-sm text-left outline-none focus-visible:ring-3 focus-visible:ring-ring/50"
      onClick={onSelect}
    >
      {children}
    </button>
  );
}
